<script>

  import UserStore from '../../stores/user';
  import fetchData from '../../api.js';
  import { createEventDispatcher } from 'svelte';
  

  let selectedPlan = null;
  let phoneNumber = '';

  
  const dispatch = createEventDispatcher();

  function close()  {
      dispatch('closePopup', {});
  }

  const plans = [
  {
    name: "הבוט החכם",
    price: "₪490",
    subtitle: "שירות בסיס חכם ללקוחות",
    features: [
      "בדיקת סטטוס משלוחים",
      "שירות לקוחות מלא מתוך תוכן האתר",
      "המלצות חכמות למוצרים"
    ],
    recommended: false
  },
  {
    name: "המנוע לצמיחה",
    price: "₪1990",
    subtitle: "כולל קידום אורגני מבוסס AI",
    features: [
      "כל מה שבחבילת הבסיס",
      "קידום אורגני באמצעות כתיבת תכנים ובניית קישורים AI",
      "שיפור SEO",
    ],
    recommended: false
  },
  {
    name: "AI למסחר חכם",
    price: "₪2999",
    subtitle: "אופטימיזציה חכמה למכירות",
    features: [
      "כל מה שבחבילת הצמיחה",
      "דיוור מייל/ווצאפ אוטומטי ללקוחות חוזרים",
      "דיוור מייל/ווצאפ לנטישות עגלה",
      "הודעות וואטסאפ להזמנות"
    ],
    recommended: false
  }
];


  async function handleSubmit() {
    if (!selectedPlan || !phoneNumber) {
      alert('נא לבחור חבילה ולהזין מספר טלפון.');
      return;
    }


    let postData = {};
    postData.phone = phoneNumber;
    postData.product_id = 10;
    postData.plan = selectedPlan.name;
    postData.action = 'product_register';
    postData.token = $UserStore.data

    let response = await fetchData(postData);  

    // כאן תוכל להחליף בקריאה ל-API, webhook וכו'
    console.log('החבילה שנבחרה:', selectedPlan.name);
    console.log('מספר טלפון:', phoneNumber);

    alert(`הפרטים נשלחו!\n\nחבילה: ${selectedPlan.name}\nטלפון: ${phoneNumber}`);

    // איפוס שדות
    phoneNumber = '';
    selectedPlan = null;

    close();

    
  }
</script>

<style>
  .card {
    @apply bg-white rounded-2xl shadow-md p-6 flex flex-col justify-between;
  }
  .recommended {
    @apply border-2 border-blue-600;
  }
  .selected {
    @apply ring-4 ring-blue-500;
  }
</style>

<div class="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto p-4">
  <div class="close absolute top-2 left-2 cursor-pointer p-4 px-[30px] bg-white text-[30px] font-bold" on:click={()=>close()}>X</div>
  {#each plans as plan}
    <div
      class="card cursor-pointer {plan.recommended ? 'recommended' : ''} {selectedPlan?.name === plan.name ? 'selected' : ''}"
      on:click={() => selectedPlan = plan}
    >
      <h2 class="text-xl font-bold mb-2 text-center">{plan.name}</h2>
      <p class="text-sm text-gray-600 text-center mb-4">{plan.subtitle}</p>
      <div class="text-center text-3xl font-semibold text-blue-700 mb-4">{plan.price}<span class="text-base">/חודש</span></div>
      <ul class="text-sm space-y-2 mb-6">
        {#each plan.features as feature}
          <li class="flex items-start gap-2"><span>✅</span> {feature}</li>
        {/each}
      </ul>
      <button class="bg-blue-600 text-white py-2 px-4 rounded-xl hover:bg-blue-700 transition">לבחירת החבילה</button>
    </div>
  {/each}
</div>

<!-- טופס שליחה -->
<div class="max-w-xl mx-auto mt-10 p-4 bg-gray-100 rounded-2xl shadow">
  <h3 class="text-lg font-semibold mb-4 text-center">מעוניין בחבילה? השאר מספר טלפון ונחזור אליך</h3>
  
  <input
    type="tel"
    placeholder="הזן מספר טלפון"
    bind:value={phoneNumber}
    class="w-full p-3 mb-4 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-start"
  />

  <button
    class="w-full bg-blue-600 text-white py-3 rounded-xl hover:bg-blue-700 transition"
    on:click={handleSubmit}
  >
    שלח פרטים
  </button>
</div>
